/* istanbul ignore file */

export enum TriggerOperator {
    Equal = 1,
    NotEqual = 2,
    LessThan = 3,
    GreaterThan = 4,
    DateFieldIsInPast = 5,
    DateFieldIsInFuture = 6,
    DateFieldIsInTheNextXDays = 7,
    DateFieldIsInTheLastXDays = 8,
    HasValue = 9,
    NoValue = 10,
    HasChanged = 11,
    GreaterThanOrEqualTo = 12,
    LessThanOrEqualTo = 13,
}
